<template>
  <q-page style="padding-top: 0px; padding-left: 0px;">
    <div class="column items-center" v-if="currentAccount">
      <h2 class="col">Account</h2>
      <div class="col q-gutter-md">
<!--        <div class="row">-->
<!--          <div style="width: 8em; text-align: right;">Company Name:</div>-->
<!--          <div class="col-auto q-pl-md">-->
<!--            {{currentAccount.companyName}}-->
<!--            <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>-->
<!--            <m-popup-edit v-model="currentAccount.companyName"-->
<!--                          @save="v => updateAccount({companyName: v})"/>-->
<!--          </div>-->
<!--        </div>-->
        <div class="row">
          <div style="width: 8em; text-align: right;">Name:</div>
          <div class="col-auto q-pl-md">
            {{currentAccount.contactName}}
            <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
            <m-popup-edit v-model="currentAccount.contactName"
                          @save="v => updateAccount({contactName: v})"/>
          </div>
        </div>
        <div class="row">
          <div style="width: 8em; text-align: right;">Email:</div>
          <div class="col-auto q-pl-md">{{currentAccount.email}}</div>
        </div>
        <div class="row">
          <div style="width: 8em; text-align: right;">Phone Number:</div>
          <div class="col-auto q-pl-md">
            {{currentAccount.contactPhone}}
            <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
            <m-popup-edit v-model="currentAccount.contactPhone"
                          @save="v => updateAccount({contactPhone: v})"/>
          </div>
        </div>
        <div class="row">
          <div style="width: 8em; text-align: right;">Shipping Address:</div>
          <div class="col-auto q-pl-md">
            <shipping-details v-model="currentAddress" ref="shippingDetails"/>
            <q-btn icon="save" class="full-width" color="primary" v-if="addressModified" @click="saveAddress">
              Save Changes
            </q-btn>
          </div>
        </div>
        <div class="row">
          <div style="width: 8em; text-align: right;">Password:</div>
          <div class="col-auto q-pl-md">
            <q-btn size="sm" flat dense icon="edit" class="q-ml-sm" @click="editPassword">Edit Password</q-btn>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapState } from 'vuex'
import MPopupEdit from '../../components/ui/MPopupEdit'
import ShippingDetails from '../../components/ui/ShippingDetails'

export default {
  name: 'PageAccountRetail',
  components: { ShippingDetails, MPopupEdit },
  data () {
    return {
      popupVal: null,
      currentAddress: {}
    }
  },
  computed: {
    ...mapState('auth', ['currentAccount']),
    addressModified () {
      let accountAddress = this.$store.getters['auth/getAccountAddress']
      return !Object.entries(this.currentAddress)
        .every(([key, value]) => accountAddress?.[key] === value)
    }
  },
  methods: {
    async saveAddress () {
      const shippingDetailsValid = await this.$refs.shippingDetails.validate()
      if (!shippingDetailsValid) return
      this.updateAccount({ addresses: [this.currentAddress] })
    },
    updateAccount (input) {
      this.$store.dispatch('auth/updateCurrentAccount', input).catch(err => {
        this.$q.notify({
          message: 'Error updating!',
          color: 'negative',
          icon: 'report_problem'
        })
      })
    },
    editPassword () {
      this.$q.dialog({
        title: 'Change Password',
        message: 'Enter a new password',
        prompt: {
          model: '',
          type: 'password',
          rules: "[ val => val && val.length > 7 || 'Please enter a password of at least 8 characters.' ]"
        },
        cancel: true
      }).onOk(newPass => {
        if (!newPass || newPass.length < 8) {
          this.$q.dialog({
            title: 'Safety first!',
            message: 'Please enter a password that\'s at least 8 characters long.',
            colour: 'red'
          })
          return
        }
        this.$q.dialog({
          title: 'Change Password',
          message: 'Repeat the new password',
          prompt: {
            model: '',
            type: 'password'
          },
          cancel: true
        }).onOk(async repeatedPass => {
          if (newPass !== repeatedPass) {
            this.$q.dialog({
              title: 'Password Not Changed!',
              message: 'Whoops, the passwords you typed didn\'t match, so we didn\'t change your password',
              colour: 'red'
            })
            return
          }
          await this.updateAccount({ password: newPass })
          this.$q.notify({
            message: 'Password was successfully changed',
            color: 'positive',
            icon: 'done'
          })
        })
      })
    }
  },
  mounted () {
    this.currentAddress = { ...this.$store.getters['auth/getAccountAddress'] }
  }
}
</script>
